import { createReactRouterApp } from '@slicesjs/react-router-app';
import { createBrowserHistory } from 'history';

import packageJson from '../package.json';
import { WidgetApp } from './widget-host-slice';

const defaultErrorHandler = (error: Error) =>
  console.error('Error creating Schedule widget', error);

const history = createBrowserHistory();

export const { mount } = createReactRouterApp(WidgetApp, {
  history,
  packageName: packageJson.name,
  onError: defaultErrorHandler,
});
